module.exports = __webpack_public_path__ + "img/Sistema-Cloud-Nuvem.a16ac86a.jpg";